import { Button, Form, Input } from "antd";

export function ResetPasswordForm({ form, loading, onSubmit }) {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={({ otp, newPassword }) => onSubmit?.({ otp, newPassword })}
      autoComplete="off"
    >
      <Form.Item
        label="Mã OTP"
        name="otp"
        rules={[
          { required: true, message: "Vui lòng nhập mã OTP!" },
          { len: 6, message: "OTP phải gồm 6 chữ số!" },
        ]}
      >
        <Input placeholder="Nhập mã OTP" size="large" maxLength={6} />
      </Form.Item>

      <Form.Item
        label="Mật khẩu mới"
        name="newPassword"
        rules={[
          { required: true, message: "Vui lòng nhập mật khẩu!" },
          {
            pattern: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
            message:
              "Mật khẩu phải có ít nhất 8 ký tự, bao gồm 1 chữ hoa và 1 số!",
          },
        ]}
      >
        <Input.Password placeholder="Nhập mật khẩu mới" size="large" />
      </Form.Item>

      <Form.Item
        label="Xác nhận mật khẩu"
        name="confirmPassword"
        dependencies={["password"]}
        rules={[
          { required: true, message: "Vui lòng xác nhận mật khẩu!" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("newPassword") === value) {
                return Promise.resolve();
              }
              return Promise.reject("Mật khẩu không trùng khớp!");
            },
          }),
        ]}
      >
        <Input.Password placeholder="Nhập lại mật khẩu" size="large" />
      </Form.Item>

      <Form.Item>
        <Button
          block
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
        >
          {loading ? "Đang đặt lại..." : "Đặt lại mật khẩu"}
        </Button>
      </Form.Item>
    </Form>
  );
}
